import { decimalLikeToDecimal } from '@snap-types/schemas/decimal';

export const priceQuantityBreaks = {
  qty_break_1: decimalLikeToDecimal.nullable(),
  qty_break_2: decimalLikeToDecimal.nullable(),
  qty_break_3: decimalLikeToDecimal.nullable(),
  qty_break_4: decimalLikeToDecimal.nullable(),
  qty_break_5: decimalLikeToDecimal.nullable(),
  qty_break_6: decimalLikeToDecimal.nullable(),
  qty_break_7: decimalLikeToDecimal.nullable(),
  qty_break_8: decimalLikeToDecimal.nullable(),
  qty_break_9: decimalLikeToDecimal.nullable(),
  qty_break_10: decimalLikeToDecimal.nullable(),
  unit_price_1: decimalLikeToDecimal.nullable(),
  unit_price_2: decimalLikeToDecimal.nullable(),
  unit_price_3: decimalLikeToDecimal.nullable(),
  unit_price_4: decimalLikeToDecimal.nullable(),
  unit_price_5: decimalLikeToDecimal.nullable(),
  unit_price_6: decimalLikeToDecimal.nullable(),
  unit_price_7: decimalLikeToDecimal.nullable(),
  unit_price_8: decimalLikeToDecimal.nullable(),
  unit_price_9: decimalLikeToDecimal.nullable(),
  unit_price_10: decimalLikeToDecimal.nullable(),
  default_unit_price: decimalLikeToDecimal.nullable(),
};
